import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/ui/Modal";
import { relationships } from "../../../../utils";
import IRecipientDetailsProps from "./Recipient";

export const Modals: FunctionComponent<IRecipientDetailsProps.Modals> = ({
  isModalOpen,
  setIsModalOpen,
  setRelationship,
  setCategory,
  setResidenceCountry,
  receivingCountryModalData,
  setBankCountry,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        header="Choose type of relationship."
        headerClass="flex justify-center font-bold text-[18px]"
        modalClass="w-4/5"
        visible={isModalOpen === "relationship"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div>
          <div className="w-[300px]">
            <div>
              <ol className="flex flex-col justify-center mt-10 space-y-8">
                {relationships.map((element, idc) => {
                  return (
                    <li
                      key={idc}
                      onClick={() => {
                        setRelationship(element);
                        setIsModalOpen("");
                      }}
                      className="pb-3 font-medium border-b-2 cursor-pointer"
                    >
                      {element}
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        header="Select Recipient Category"
        headerClass="flex justify-center font-bold text-[18px]"
        modalClass="w-4/5"
        visible={isModalOpen === "category"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div>
          <div className="w-[300px]">
            <div>
              <ol className="flex flex-col justify-center mt-10 space-y-8">
                <li
                  onClick={() => {
                    setCategory("Individual");
                    setIsModalOpen("");
                  }}
                  className="pb-3 font-medium border-b-2 cursor-pointer"
                >
                  Individual
                </li>
                <li
                  onClick={() => {
                    setCategory("Institution");
                    setIsModalOpen("");
                  }}
                  className="pb-3 font-medium cursor-pointer"
                >
                  Institution
                </li>
              </ol>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        header="Country of Residence"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 !rounded-t-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "residenceCountry"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryModalData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-11 lg:border-none lg:py-0 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setIsModalOpen("");
                    setResidenceCountry(data.countryName);
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.countryName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    <div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      <Modal
        header="Bank Account Number"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 !rounded-t-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "bankCountry"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryModalData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-11 lg:border-none lg:py-0 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setIsModalOpen("");
                    setBankCountry(data.countryName);
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.countryName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    <div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      <Modal
        header="Cancel Transaction"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 rounded-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancel"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10 space-y-6">
          <span className="font-ssp text-[22px]">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex space-x-10">
            <button
              onClick={() => navigate("/remittance")}
              className="px-6 py-2 font-bold text-white rounded bg-primary-650 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="px-6 py-2 font-bold text-white rounded bg-primary font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
